// src/admin/FormEditor/utils/quillConversion.js

/**
 * Converts Quill's class-based alignment to inline styles
 * This ensures alignment works correctly when rendered outside of Quill
 * @param {string} html - The HTML content to process
 * @return {string} - The processed HTML with inline styles added
 */
function convertQuillAlignmentToInlineStyles(html) {
  if (!html) return html;

  // Define the mapping of alignment classes to CSS styles
  const alignmentStyles = {
    "ql-align-center": "text-align: center;",
    "ql-align-right": "text-align: right;",
    "ql-align-justify": "text-align: justify;",
    // Default left alignment doesn't need a style
  };

  // Process each alignment class
  let processedHtml = html;

  Object.entries(alignmentStyles).forEach(([className, styleValue]) => {
    // Regular expression to find elements with the alignment class
    // This regex looks for elements with the specific class, whether it appears alone or with other classes
    const regex = new RegExp(`class="([^"]*\\b${className}\\b[^"]*)"`, "g");

    processedHtml = processedHtml.replace(regex, (match, capturedClasses) => {
      // Check if there's already a style attribute
      if (match.includes('style="')) {
        // Add to existing style attribute
        return match.replace(
          /style="([^"]*)"/,
          (styleMatch, existingStyles) => {
            return `style="${existingStyles} ${styleValue}"`;
          }
        );
      } else {
        // Add new style attribute
        return `${match} style="${styleValue}"`;
      }
    });
  });

  // Handle hanging-indent elements
  const hangingIndentRegex = /class="([^"]*\bhanging-indent-true\b[^"]*)"/g;
  processedHtml = processedHtml.replace(
    hangingIndentRegex,
    (match, capturedClasses) => {
      const hangingStyle = "padding-left: 2rem; text-indent: -2rem;";

      if (match.includes('style="')) {
        // Add to existing style attribute
        return match.replace(
          /style="([^"]*)"/,
          (styleMatch, existingStyles) => {
            return `style="${existingStyles} ${hangingStyle}"`;
          }
        );
      } else {
        // Add new style attribute
        return `${match} style="${hangingStyle}"`;
      }
    }
  );

  return processedHtml;
}

export { convertQuillAlignmentToInlineStyles };
